import { render, staticRenderFns } from "./PlosEx.vue?vue&type=template&id=dcd97a34"
import script from "./PlosEx.vue?vue&type=script&lang=js"
export * from "./PlosEx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports